export default __webpack_public_path__ + "static/media/lacessories14.3f642bb6.jpeg";